import React from "react";
import PropTypes from "prop-types";
import ProductItem from "theme/modules/ProductView/ProductItem";
import GridCards from "./GridCards";

const ProductsGrid = (props) => (
  <GridCards loading={props.loading}>
    {props.products.map((product, index) => (
      <ProductItem
        isGrid
        key={product.sku}
        products={props.products}
        categoryName={props.categoryName}
        breadcrumb={props.breadcrumb}
        location={props.location}
        index={index}
        product={product}
        {...product}
      />
    ))}
  </GridCards>
);

ProductsGrid.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool,
};

export default ProductsGrid;
